export const getRatingIconIndex = (percent: number, levels: number): number => {
  const step = 100 / levels;
  for (let index = 0; index < levels - 1; index++) {
    if (percent <= step * (index + 1)) {
      return index;
    }
  }
  return levels - 1;
};
